import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=4691469b&scoped=true&"
import script from "./RatingStar.vue?vue&type=script&lang=js&"
export * from "./RatingStar.vue?vue&type=script&lang=js&"
import style0 from "./RatingStar.vue?vue&type=style&index=0&id=4691469b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691469b",
  null
  
)

export default component.exports